import React from 'react';
import { useT } from '../context/AppContext';
import './LogoutModal.css';

const LogoutModal = ({ isOpen, onClose, onConfirm }) => {
  const tr = useT();
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-icon">
          <i className="fas fa-sign-out-alt"></i>
        </div>
        <h2>{tr('deconnexion_titre')}</h2>
        <p>{tr('deconnexion_confirm')}</p>
        <div className="modal-actions">
          <button className="btn-modal-cancel" onClick={onClose}>{tr('annuler')}</button>
          <button className="btn-modal-confirm" onClick={onConfirm}>
            <i className="fas fa-sign-out-alt"></i> {tr('se_deconnecter')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutModal;